import { render, staticRenderFns } from "./XOverlay.vue?vue&type=template&id=4614695a&scoped=true&"
import script from "./XOverlay.vue?vue&type=script&lang=ts&"
export * from "./XOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./XOverlay.vue?vue&type=style&index=0&id=4614695a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4614695a",
  null
  
)

export default component.exports